import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { getAdminStoreState } from "@/stores";

const GuestLayout = () => {
  return <Outlet />;
};

export const Route = createFileRoute("/_guest")({
  component: GuestLayout,
  validateSearch: z.object({
    redirect: z.string().optional().catch(""),
  }),
  beforeLoad: ({ search }) => {
    const { token } = getAdminStoreState();

    if (token) {
      throw redirect({ to: search.redirect ?? "/profiles" });
    }
  },
});
